<template>
	<div>
		<ul class="paganation"> 
			<li @click="getPagingData(prePage)"><i class="fa fa-angle-left"></i></li>
			<li v-for="item in  pagingList" :class="item.gclass" @click="getPagingData(item.number)">{{item.number}}</li>
			<li @click="getPagingData(nextPage)"><i class="fa fa-angle-right"></i></li>
		</ul>
		<div style='clear:both;height:40px;'></div>
	</div>	
</template>


<script>
export default {
  name: 'Paganation',
  props:["paging"],
  watch: {
	  paging() {
		this.prePage = this.paging.pre_page;
		this.nextPage = this.paging.next_page;
		this.pagingList = this.paging.list;
	  }
  },
  data () {
	
	return {
  	   pagingList:[],
	   prePage:1,
	   nextPage:1,

   }
  },
  created() {
	 this.prePage = this.paging.pre_page;
	 this.nextPage = this.paging.next_page;
	 if(!this.paging.list)this.pagingList = [];
	 else this.pagingList = this.paging.list;
  },
  methods: {
      getPagingData(number) {
		this.$emit('getDataListByPaging',number);
	  },
	 
  },
  mounted: function() {
	
  }

}
</script>

<style lang="scss" scoped>
.paganation {
	display: table;
	margin:30px auto;
	li {
		float:left;
		width:30px;
		text-align:center;
		line-height:30px;
		cursor:pointer;
		color:#999;
		font-size:11pt;
	}
	li:first-child {
		margin-right:7px;
		width:30px;
		height:30px;
		border:solid 1px #AAAAAA;
		border-radius:15px;
		padding-right:2px;
		font-weight:bold;
		color:#000;
	}
	li:last-child {
		width:30px;
		height:30px;
		border:solid 1px #AAAAAA;
		border-radius:15px;
		padding-left:2px;
		font-weight:bold;
		color:#000;
		margin-left:7px;
	}
	li.active {
		font-weight:bold;
		color:#000;
	}
}

</style>